import Link from 'gatsby-link';
import React, { Component } from 'react';
import { Button, Image, List, Responsive } from 'semantic-ui-react';

import BasicContainer from './BasicContainer';

const uuidv4 = require('uuid/v4');

export default class Footer extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#F2F2F2' }}>      
        <BasicContainer textAlign="center">
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <List horizontal divided size="medium">
            <List.Item>
              <List.Content verticalAlign="top">
                <List.Header>MAYAD POST</List.Header>
                <List.Header as={Link} to="/" className="mpost-link--default footer">HOME</List.Header>
                <List.Header as={Link} to="/work" className="mpost-link--default footer">WORK</List.Header>
                <List.Header as={Link} to="/services" className="mpost-link--default footer">SERVICES</List.Header>
                <List.Header as={Link} to="/contact" className="mpost-link--default footer">CONTACT US</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content verticalAlign="top">
                <List.Header>RECENT PROJECTS</List.Header>
                <List.Description as={Link} to="/work/" className="mpost-link--default footer">Audsley and Tucker</List.Description>
                <List.Description as={Link} to="/work/" className="mpost-link--default footer">McKinzie and Scott</List.Description>
                <List.Description as={Link} to="/work/" className="mpost-link--default footer">Pao and Cherry</List.Description>
                <List.Description className="mpost-link--default footer">&nbsp;</List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header>PARTNERS</List.Header>
                <List.Description as="a" href="http://amady.com.ph" className="mpost-link--default footer">Amady</List.Description>
                <List.Description as="a" href="http://mayadstudios.com/" className="mpost-link--default footer">Mayad Studios</List.Description>
                <List.Description as="a" href="http://mayadacademy.com/" className="mpost-link--default footer">Mayad Academy</List.Description>
                <List.Description className="mpost-link--default footer">&nbsp;</List.Description>
              </List.Content>
            </List.Item>
          </List>
          </Responsive>
          <Responsive {...Responsive.onlyMobile}>
          <List size="medium">
            <List.Item>
              <List.Content verticalAlign="top">
                <List.Header>MAYAD POST</List.Header>
                <List.Header as={Link} to="/" className="mpost-link--default footer">HOME</List.Header>
                <List.Header as={Link} to="/work" className="mpost-link--default footer">WORK</List.Header>
                <List.Header as={Link} to="/services" className="mpost-link--default footer">SERVICES</List.Header>
                <List.Header as={Link} to="/contact" className="mpost-link--default footer">CONTACT US</List.Header>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content verticalAlign="top">
                <List.Header>RECENT PROJECTS</List.Header>
                <List.Description as={Link} to="/work/" className="mpost-link--default footer">Audsley and Tucker</List.Description>
                <List.Description as={Link} to="/work/" className="mpost-link--default footer">McKinzie and Scott</List.Description>
                <List.Description as={Link} to="/work/" className="mpost-link--default footer">Pao and Cherry</List.Description>
                <List.Description className="mpost-link--default footer">&nbsp;</List.Description>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header>PARTNERS</List.Header>
                <List.Description as="a" href="http://amady.com.ph" className="mpost-link--default footer">Amady</List.Description>
                <List.Description as="a" href="http://mayadstudios.com/" className="mpost-link--default footer">Mayad Studios</List.Description>
                <List.Description as="a" href="http://www.chapters.ph/" className="mpost-link--default footer">Chapters PH</List.Description>
                <List.Description className="mpost-link--default footer">&nbsp;</List.Description>
              </List.Content>
            </List.Item>
          </List>
            </Responsive>
          <div className="mpost-footer--divider" />
          <Button className="mpost-footer-social" as="a" href="mailto:info@mayadpostprod.com" circular icon="mail" />
          <Button className="mpost-footer-social" circular as="a" target="_blank" href="https://www.facebook.com/mpostph/" icon="facebook" />
          <Button className="mpost-footer-social" circular as="a" target="_blank" href="https://vimeo.com/mayadstudios" icon="vimeo" />
          <Button className="mpost-footer-social" circular as="a" target="_blank" href="https://www.youtube.com/channel/UC_zqrs9qTToNw-EEH27cATw" icon="youtube" />
          <Image centered style={{ margin: '20px auto', opacity: 0.5 }} src={require('../assets/img/logo-gray.svg')} size="tiny" />
          <p className="mpost-copyright--text">&copy; 2018 MAYAD POST PRODUCTIONS. ALL RIGHTS RESERVED</p>
        </BasicContainer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js